import "./index.scss";
import "./images/drinkaware-logo.svg";

const suppressSingleTabLinks = () => {
  const tabs = document.querySelectorAll("ul.tabs.wc-tabs > li");
  if (tabs.length === 1) {
    const link = tabs[0].querySelector("a[href]");
    if (link) {
      link.classList.add("suppress-link");
    }
  }
}

const initOutOfStockForm = () => {
  const blocks = document.querySelectorAll(".out-of-stock-area");
  blocks.forEach(block => {
    const button = block.querySelector(".out-of-stock-area__button");
    const form = block.querySelector(".out-of-stock-area__form");
    button.addEventListener('click', e => {
      e.preventDefault();
      button.classList.toggle('out-of-stock-area__button--selected');
      form.classList.toggle('out-of-stock-area__form--hidden');
    });
  })
}

window.addEventListener("DOMContentLoaded", suppressSingleTabLinks);
window.addEventListener("DOMContentLoaded", initOutOfStockForm);
